import branch from "branch-sdk";
import { makeAutoObservable } from "mobx";

import { MINI_APP_ID } from "@/shared/config";

import { IDeepLinkData } from "./types/deepLink";

export class DeepLinkStore {
  constructor() {
    makeAutoObservable(this);
  }

  init({ handleLink }: { handleLink: (data: IDeepLinkData) => void }) {
    branch.init(
      import.meta.env.VITE_BRANCH_API_KEY as string,
      {},
      (err, data) => {
        if (!err && data) {
          if (window.location.search.includes("?_branch_match_id")) {
            window.history.replaceState({}, "", window.location.origin);
          }

          const dataParsed = data.data_parsed as IDeepLinkData;

          handleLink(dataParsed);
        }
      }
    );
  }

  share(data: IDeepLinkData) {
    return new Promise<string>((resolve) => {
      branch.link(
        {
          data: {
            $desktop_url: window.location.origin,
            id: MINI_APP_ID,
            to_url: data.to_url,
            command: data.command,
            assistant_id: data.assistant_id,
          },
        },
        (_, link) => {
          if (link) resolve(link);
        }
      );
    });
  }
}
